import {axios} from '@/utils/request'

const api = {
    user: '/user',
    role: '/role',
}

export default api

// post
export function postAction(url, parameter, timeout) {
    return axios({
        url: url,
        method: 'post',
        data: parameter,
        timeout: timeout == undefined ? 0 : 10000
    })
}

// post
export function postActionMultipart(url, parameter) {
    return axios({
        url: url,
        method: 'post',
        data: parameter,
        headers: {
            'Content-Type': 'multipart/form-data;'
        }
    })
}

// post method= {post | put}
export function httpAction(url, parameter, method) {
    return axios({
        url: url,
        method: method,
        data: parameter
    })
}

// put
export function putAction(url, parameter) {
    return axios({
        url: url,
        method: 'put',
        data: parameter
    })
}

// fileAction
export function fileAction(url, parameter) {
    return axios({
        method: 'post',
        url: url,
        data: parameter,
        responseType: 'blob',
        timeout: 0
    })
}

// get
export function getAction(url, parameter) {
    return axios({
        url: url,
        method: 'get',
        params: parameter
    })
}

// deleteAction
export function deleteAction(url, parameter) {
    return axios({
        url: url,
        method: 'delete',
        params: parameter
    })
}
